import Vue from 'vue'
import Vuex from 'vuex'
import { coleccion_blog, auth } from '@/FirebaseConfig'
import { toSlug } from '@/Helper'
Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    registro: [],
    cantidad_de_registros: 0,
    entrada: {
      contenido: '',
      titulo: '',
      imagen: '',
      etiquetas: []
    },
  },
  actions: {
    obtener_por_etiqueta: async ( context, {etiqueta, limite}) => {
      const coleccion = await coleccion_blog.orderBy('creado_el', 'desc').where('etiquetas', 'array-contains', etiqueta).limit(limite).get()
      return coleccion.docs.map( doc => ({...doc.data(), id: doc.id, creado_el: doc.data().creado_el.toDate() }) )
    },
    obtener_por_slug: async( context, _slug)=> {
      const coleccion = await coleccion_blog.where('slug', '==', _slug).get()
      return coleccion.empty ? [] : coleccion.docs.map( doc => ({...doc.data(), id: doc.id, creado_el: doc.data().creado_el.toDate() }) )[0]
    },
    obtener_todos: ({state})=>{
      coleccion_blog.limit(10).orderBy('creado_el', 'desc').onSnapshot(({docs, size})=> {
        const registro = []
        docs.map( doc => registro.push({...doc.data(), id: doc.id, creado_el: doc.data().creado_el.toDate() }))
        state.registro = registro
        state.cantidad_de_registros = size
      })
    },
    agregar: ( {state, dispatch}) => coleccion_blog.add({
      ...state.entrada, 
      creado_el: new Date, 
      creado_por: auth.currentUser.uid, 
      slug: toSlug(state.entrada.titulo)
    }).then(()=>dispatch('limpiar')),

    actualizar: ( {state, dispatch} ) => {
      coleccion_blog.doc(state.entrada.id).update({...state.entrada, actualizado_el: new Date, actualizado_por: auth.currentUser.uid, slug: toSlug(state.entrada.titulo)}).then(()=>dispatch('limpiar'))
    },
    eliminar:  ( context, id) => {
      coleccion_blog.doc(id).delete()
    },
    obtener_por_id: ( {state}, _id ) =>  state.entrada = state.registro.filter( ({id}) => id == _id )[0],
    limpiar: ( {state} ) => state.entrada = {
      contenido: '',
      titulo: '',
      imagen: '',
      etiquetas: [],
    }
  },
  getters: {
    registro: ({registro}) => registro,
    cantidad_de_registros: ({cantidad_de_registros}) => cantidad_de_registros,
    entrada: ({entrada}) => entrada || {},
  }

}